import React from 'react';
import Grid from '@material-ui/core/Grid';
import Daily from './Daily/Daily';
import Monthly from './Monthly/Monthly';
import useTitle from 'hooks/useTitle';

const Reports = () => {
  useTitle("گزارش ها")
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Daily />
      </Grid>
      <Grid item xs={12} md={6}>
        <Monthly />
      </Grid>
    </Grid>
  );
};

export default Reports;
